import {Component, Input} from '@angular/core';
import {StoryCard} from "../story-card";
import {AnimationItem} from "lottie-web";
import {ButtonColor} from "../../../atoms/button/button-color";
import {StoryTheme} from "../story-theme";
import {DataService} from "../../../services/data.service";
import {take} from "rxjs";

@Component({
  selector: 'brt-quiz-card',
  templateUrl: './quiz-card.component.html',
  styleUrls: ['./quiz-card.component.scss']
})
export class QuizCardComponent {

  animation!: AnimationItem;
  buttonColor: ButtonColor = "river";

  @Input('card-data') set setCardData(val: StoryCard) {
    this.cardData = val;
    this.buttonColor = this.getButtonColor();
    // console.log(this.buttonColor);
  };

  @Input('current') set setCurrent(val: boolean) {
    this.current = val;

    if(this.animation) {
      if (this.current) {
        this.animation.play();
      } else {
        this.animation.stop();
      }

    }
  }

  current: boolean = false;
  cardData!: StoryCard;


  onAnimationCreated($event: AnimationItem) {
    this.animation = $event;

    if(this.current) this.animation.play();
  }

  getButtonColor(): ButtonColor {
    switch (this.cardData.theme) {
      case StoryTheme.BLACK:
        return "river";
      case StoryTheme.DARKBLUE:
        return "river";
      case StoryTheme.DARKGREEN:
        return "green";
      case StoryTheme.GREY:
        return "gray";
      case StoryTheme.LIGHTBLUE:
        return "river";
      case StoryTheme.LIGHTGREEN:
        return "green";
      case StoryTheme.PETROL:
        return "red";
      case StoryTheme.RED:
        return "red";
      case StoryTheme.WHITE:
        return "white";
      case StoryTheme.YELLOW:
        return "red";
      default:
        return "river";
    }
  }
}
